export const DEFAULT_SERVICE_NAME = 'Wiren Board Cloud';

export const getServiceName = () =>
  (import.meta.env.SERVICE_NAME as string) || DEFAULT_SERVICE_NAME;

// Wiren Board Cloud keeps its original hardcoded texts; only custom brands are substituted
export const isCustomBranding = () =>
  getServiceName() !== DEFAULT_SERVICE_NAME;

// Env-provided URLs go into :href, so restrict them to http(s) or root-relative
export const isSafeUrl = (url: string) => /^(https?:\/\/|\/(?!\/))/.test(url);

export const getDocsUrl = (locale?: string) => {
  const url = (import.meta.env.SERVICE_DOCS_URL as string) ?? '';
  const urlEn = (import.meta.env.SERVICE_DOCS_URL_EN as string) ?? '';

  if (locale === 'en' && isSafeUrl(urlEn)) {
    return urlEn;
  }

  return isSafeUrl(url) ? url : '';
};

// The anchor must match the language of the resolved page, not the UI locale
export const getRolesDocsUrl = (locale?: string) => {
  const urlEn = (import.meta.env.SERVICE_DOCS_URL_EN as string) ?? '';

  if (locale === 'en' && isSafeUrl(urlEn)) {
    return `${urlEn}#Roles`;
  }

  const url = getDocsUrl();
  return url ? `${url}#Роли` : '';
};
